// AdminFrontend/src/unicodex_ui/admin/services/adminPosApi.js
import adminApiClient from "./adminApiClient";

const adminPosApi = {
  // Terminals
  async listTerminals(params) {
    const res = await adminApiClient.get("/api/pos/terminals", { params });
    return res.data;
  },
  async createTerminal(payload) {
    const res = await adminApiClient.post("/api/pos/terminals", payload);
    return res.data;
  },

  // Shifts
  async listShifts(params) {
    const res = await adminApiClient.get("/api/pos/shifts", { params });
    return res.data;
  },
  async openShift(payload) {
    const res = await adminApiClient.post("/api/pos/shifts/open", payload);
    return res.data;
  },
  async closeShift(shiftId, payload) {
    const res = await adminApiClient.post(`/api/pos/shifts/${shiftId}/close`, payload);
    return res.data;
  },
  async getShiftSummary(shiftId) {
    const res = await adminApiClient.get(`/api/pos/shifts/${shiftId}/summary`);
    return res.data;
  },

  // Sales
  async listSales(params) {
    const res = await adminApiClient.get("/api/pos/sales", { params });
    return res.data;
  },
  async getSale(saleId) {
    const res = await adminApiClient.get(`/api/pos/sales/${saleId}`);
    return res.data;
  },
  async voidSale(saleId, payload) {
    const res = await adminApiClient.post(`/api/pos/sales/${saleId}/void`, payload);
    return res.data;
  },
  async refundSale(saleId, payload) {
    const res = await adminApiClient.post(`/api/pos/sales/${saleId}/refund`, payload);
    return res.data;
  },

  // Stock check
  async stockCheck(params) {
    const res = await adminApiClient.get("/api/pos/stock/check", { params });
    return res.data;
  },

  // Product search (Option A)
  async searchProducts(params) {
    const res = await adminApiClient.get("/api/identity/products", { params });
    return res.data;
  },
};

export default adminPosApi;
